"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VTable;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Heading = _interopRequireDefault(require("../../Typography/Heading/Heading"));

require("./VTable.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Table
 */
function VTable(_ref) {
  var rows = _ref.rows,
      ariaLabel = _ref.ariaLabel,
      tableHeading = _ref.tableHeading,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "VTable"
  }, /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
    component: _Paper.default
  }, tableHeading !== '' && /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    level: "4"
  }, tableHeading)), /*#__PURE__*/_react.default.createElement(_Table.default, {
    "aria-label": ariaLabel,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, rows.tableHead.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      key: index
    }, value);
  }))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows.data.map(function (dataRow, index) {
    return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      key: index
    }, dataRow.map(function (value, index) {
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        key: index
      }, value);
    }));
  })))));
}

VTable.propTypes = {
  /** Table label */
  ariaLabel: _propTypes.default.string.isRequired,

  /** Table heading */
  tableHeading: _propTypes.default.any,

  /** Table size */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /** Table rows (with headings) */
  rows: _propTypes.default.shape({
    /** Table headings */
    tableHead: _propTypes.default.array.isRequired,

    /** Table data */
    data: _propTypes.default.arrayOf(_propTypes.default.array).isRequired
  }).isRequired
};
VTable.defaultProps = {
  tableHeading: '',
  size: 'medium'
};